import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Link2, Car, ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import { useT } from '../services/i18n';
import { productsAPI } from '../services/api';

const MAX_VISIBLE = 12;
const PILL = 'inline-flex items-center gap-1 text-sm px-3 py-1.5 rounded-full border border-gray-200 text-gray-700 hover:border-orange-400 hover:text-orange-600 transition-colors';

const SubGroup = ({ group, index }) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const hidden = group.items.length - MAX_VISIBLE;
  const items = open ? group.items : group.items.slice(0, MAX_VISIBLE);
  return (
    <div data-testid={`related-subs-group-${index}`} className="mb-4 last:mb-0">
      <h2 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-3">
        <Link2 size={16} className="text-orange-500" /> {t('product.relatedSubs', { cat: group.category.name })}
      </h2>
      <ul className="flex flex-wrap gap-2">
        {items.map((x, i) => (
          <li key={x.path}><Link to={x.path} data-testid={`related-sub-${index}-${i}`} className={PILL}>{x.name}</Link></li>
        ))}
        <li>
          <Link to={group.category.path} data-testid={`related-subs-category-${index}`} className={`${PILL} border-orange-200 text-orange-600 bg-orange-50`}>
            {t('product.relatedAll', { cat: group.category.name })} <ArrowRight size={12} />
          </Link>
        </li>
        {hidden > 0 && (
          <li>
            <button type="button" onClick={() => setOpen(!open)} data-testid={`related-subs-toggle-${index}`} className={`${PILL} border-dashed text-gray-500`}>
              {open ? <><ChevronUp size={12} /> {t('product.relatedLess')}</> : <><ChevronDown size={12} /> {t('product.relatedMore', { n: hidden })}</>}
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export const RelatedLinksBlock = ({ productId }) => {
  const { t, lang } = useT();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    setData(null);
    productsAPI.getRelatedLinks(productId, lang).then((d) => alive && setData(d)).catch(() => alive && setData({ groups: [], vehicles: [] }));
    return () => { alive = false; };
  }, [productId, lang]);
  if (!data || (!data.groups.length && !data.vehicles.length)) return null;
  return (
    <section className="bg-white rounded-lg shadow-sm p-4 mb-6" data-testid="product-related-links">
      {data.groups.map((g, i) => <SubGroup key={g.category.slug} group={g} index={i} />)}
      {data.vehicles.length > 0 && (
        <div data-testid="related-vehicles" className={data.groups.length ? 'mt-4 pt-4 border-t border-gray-100' : ''}>
          <h2 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-3"><Car size={16} className="text-orange-500" /> {t('product.relatedVehicles')}</h2>
          <ul className="flex flex-wrap gap-2">
            {data.vehicles.map((v, i) => (
              <li key={v.path}><Link to={v.path} data-testid={`related-vehicle-${i}`} className={PILL}>{v.label}</Link></li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};
